const data = [
  {
    url: '/best-workplaces-for-innovators/2019',
    id: '90378273',
    slug: 'best-workplaces-for-innovators-2019',
    tag: 'bwp'
  }
];

export default data;
